/** Spanish for the statements area. Keys are the exact English strings the UI renders. */
const statements = {
  'Statement CC recipients': 'Destinatarios en copia del estado de cuenta',
  'QuickBooks sync brings in the primary email only. Add its Cc addresses here for MedEffects statements.':
    'La sincronización de QuickBooks solo trae el correo principal. Agregue aquí las direcciones en copia para los estados de cuenta de MedEffects.',
  'No additional recipients': 'Sin destinatarios adicionales',
  'CC email addresses': 'Direcciones de correo en copia',
  'One address per line, or separated by commas': 'Una dirección por línea o separadas por comas',
  'Use at most five CC email addresses.': 'Use como máximo cinco direcciones de correo en copia.',
  'The CC recipients were not saved. Please try again.':
    'No se guardaron los destinatarios en copia. Inténtelo de nuevo.',
  'Add CC': 'Agregar copia',
  'Edit CC': 'Editar copia',
  'Save recipients': 'Guardar destinatarios',
  '+{count} CC': '+{count} en copia',
  'Sending status is unverified': 'El estado del envío no está verificado',
  'These are the last reported eligible customers. Refresh to verify the next run.':
    'Estos son los últimos clientes elegibles registrados. Actualice para verificar la próxima ejecución.',
  'Automatic sending status needs verification':
    'Es necesario verificar el estado del envío automático',
  'Refresh the sending status to verify the current checks. This screen cannot confirm whether the next run will send.':
    'Actualice el estado del envío para verificar los controles actuales. Esta pantalla no puede confirmar si la próxima ejecución enviará estados de cuenta.',
  'Statement data and duplicate prevention are verified':
    'Los datos del estado de cuenta y la prevención de duplicados están verificados',
  'The statement date, complete customer list, invoice due dates and delivery index passed their checks.':
    'La fecha del estado de cuenta, la lista completa de clientes, las fechas de vencimiento y el índice de envíos pasaron sus controles.',
  'Refresh the sending status and resolve the reported checks before enabling statements.':
    'Actualice el estado del envío y resuelva los controles indicados antes de activar los estados de cuenta.',
  'Refresh the plan for today before sending.': 'Actualice el plan de hoy antes de enviar.',
  'The live QuickBooks company file is required.':
    'Se requiere el archivo de la empresa de producción de QuickBooks.',
  'The customer list is incomplete. Sending is blocked.':
    'La lista de clientes está incompleta. El envío está bloqueado.',
  'Invoice due dates are missing. Sending is blocked.':
    'Faltan las fechas de vencimiento de las facturas. El envío está bloqueado.',
  'Duplicate prevention could not be verified. Sending is blocked.':
    'No se pudo verificar la prevención de duplicados. El envío está bloqueado.',
  'A statement readiness check needs attention. Sending is blocked.':
    'Un control de preparación de estados de cuenta requiere atención. El envío está bloqueado.',
  // Page header and tabs
  Statements: 'Estados de cuenta',
  'Weekly open-item statements: whether they are going out, who receives one, and what they say.':
    'Estados de cuenta semanales de partidas abiertas: si se están enviando, quién recibe uno y qué dicen.',
  'Statements views': 'Vistas de estados de cuenta',
  Recipients: 'Destinatarios',
  'Credit limit messages': 'Mensajes de límite de crédito',
  Rules: 'Reglas',

  // Shared furniture
  'Try again': 'Inténtelo de nuevo',
  Refresh: 'Actualizar',
  'Refreshing...': 'Actualizando...',
  Close: 'Cerrar',
  Details: 'Detalles',
  Cancel: 'Cancelar',
  Save: 'Guardar',
  'Saving...': 'Guardando...',
  Edit: 'Editar',
  Add: 'Agregar',
  Customer: 'Cliente',
  Customers: 'Clientes',
  Email: 'Correo electrónico',
  Balance: 'Saldo',
  Date: 'Fecha',
  Type: 'Tipo',
  Amount: 'Importe',
  Clinics: 'Clínicas',
  Hidden: 'Oculto',
  Inactive: 'Inactivo',
  Unreviewed: 'Sin revisar',
  Failed: 'Con error',
  unknown: 'desconocido',
  'unknown error': 'error desconocido',
  ready: 'listo',
  'not ready': 'no listo',
  'Before sending': 'Antes de enviar',
  'This was checked less than a minute ago. It reads the whole QuickBooks company file, so it is limited to once a minute - try again shortly.':
    'Esto se consultó hace menos de un minuto. Lee todo el archivo de empresa de QuickBooks, por lo que está limitado a una vez por minuto; inténtelo de nuevo en un momento.',

  // The API-envelope refusals (unwrap)
  'The API did not return a statement report. This usually means the app is pointed at the wrong address.':
    'La API no devolvió un informe de estados de cuenta. Esto suele significar que la aplicación apunta a la dirección equivocada.',
  'The API did not return a run plan. This usually means the app is pointed at the wrong address.':
    'La API no devolvió un plan de ejecución. Esto suele significar que la aplicación apunta a la dirección equivocada.',
  'The API did not return a customer list. This usually means the app is pointed at the wrong address.':
    'La API no devolvió una lista de clientes. Esto suele significar que la aplicación apunta a la dirección equivocada.',
  'The API did not return a run. This usually means the app is pointed at the wrong address.':
    'La API no devolvió una ejecución. Esto suele significar que la aplicación apunta a la dirección equivocada.',
  'The API did not return a credit limit message. This usually means the app is pointed at the wrong address.':
    'La API no devolvió un mensaje de límite de crédito. Esto suele significar que la aplicación apunta a la dirección equivocada.',
  'The API did not return a template. This usually means the app is pointed at the wrong address.':
    'La API no devolvió una plantilla. Esto suele significar que la aplicación apunta a la dirección equivocada.',
  'The API did not return a save result. This usually means the app is pointed at the wrong address.':
    'La API no devolvió un resultado de guardado. Esto suele significar que la aplicación apunta a la dirección equivocada.',

  // Server sentences a reader of these screens can hit (statements.service.ts, statements.controller.ts)
  'No QuickBooks company is connected, so there is nothing to read. This is a connection problem, not an empty ledger.':
    'No hay ninguna empresa de QuickBooks conectada, así que no hay nada que leer. Es un problema de conexión, no un libro mayor vacío.',
  'Could not read QuickBooks customers; nothing can be computed.':
    'No se pudieron leer los clientes de QuickBooks; no se puede calcular nada.',
  'QuickBooks returned customers but not one carried a Balance field. This is a broken read, not an empty ledger - every number derived from it is unavailable.':
    'QuickBooks devolvió clientes, pero ninguno traía el campo Balance. Es una lectura defectuosa, no un libro mayor vacío: ninguna cifra derivada de ella está disponible.',
  'One or more QuickBooks reads failed. Statements built now could omit credits or payments a customer has already made, so none were built.':
    'Una o más lecturas de QuickBooks fallaron. Los estados de cuenta generados ahora podrían omitir créditos o pagos que un cliente ya realizó, así que no se generó ninguno.',
  'That customer exists in this QuickBooks company file but carries no open balance.':
    'Ese cliente existe en este archivo de empresa de QuickBooks, pero no tiene saldo abierto.',
  'No customer with that id exists in this QuickBooks company file.':
    'No existe ningún cliente con ese ID en este archivo de empresa de QuickBooks.',
  'No statement could be built for that customer.':
    'No se pudo generar un estado de cuenta para ese cliente.',
  'Not a valid clinic id.': 'El ID de clínica no es válido.',
  'No such clinic in the connected QuickBooks company file.':
    'No existe esa clínica en el archivo de empresa de QuickBooks conectado.',
  'Statement message must be text.': 'El mensaje del estado de cuenta debe ser texto.',

  // Rules tab
  'Could not read the sending status.': 'No se pudo leer el estado de envío.',
  'Refresh the sending status': 'Actualizar el estado de envío',
  'Re-reading the company file...': 'Releyendo el archivo de empresa...',
  'These numbers did not come from the live QuickBooks company file':
    'Estas cifras no provienen del archivo de empresa de QuickBooks en producción',
  'environment: {environment}': 'entorno: {environment}',
  'environment unknown': 'entorno desconocido',
  'A live run refuses to send from anything but the production ledger.':
    'Una ejecución real se niega a enviar desde cualquier libro mayor que no sea el de producción.',
  'Statements send automatically every week':
    'Los estados de cuenta se envían automáticamente cada semana',
  'Statements are not being sent automatically':
    'Los estados de cuenta no se están enviando automáticamente',
  'The next run is': 'La próxima ejecución es',
  'not known': 'desconocida',
  ', and it will email': ', y enviará por correo a',
  customer: 'cliente',
  customers: 'clientes',
  'Nothing will be emailed to anyone. The weekly slot is':
    'No se enviará nada a nadie. El horario semanal es',
  'every Tuesday at noon Central': 'cada martes al mediodía, hora central',
  '; if everything below were ready,': '; si todo lo de abajo estuviera listo,',
  'customer would receive a statement.': 'cliente recibiría un estado de cuenta.',
  'customers would receive a statement.': 'clientes recibirían un estado de cuenta.',
  '{count} customer has more open documents than fit on a statement.':
    '{count} cliente tiene más documentos abiertos de los que caben en un estado de cuenta.',
  '{count} customers have more open documents than fit on a statement.':
    '{count} clientes tienen más documentos abiertos de los que caben en un estado de cuenta.',
  'Their total is correct, but the rows printed beneath it will not add up to it - the document says so, and their accounts-payable clerk will ask.':
    'Su total es correcto, pero las filas impresas debajo no sumarán ese total; el documento lo indica, y su encargado de cuentas por pagar preguntará.',
  'showing {shown} of {total} open documents': 'se muestran {shown} de {total} documentos abiertos',
  '{shown} of {count} are named here.': 'Aquí se nombran {shown} de {count}.',
  'Every invoice was aged from its transaction date because none carried a due date. That is usually a broken read, not real data, and a live run refuses to start on it - nothing will be sent until it is resolved.':
    'La antigüedad de todas las facturas se calculó desde su fecha de transacción porque ninguna tenía fecha de vencimiento. Eso suele ser una lectura defectuosa, no datos reales, y una ejecución real se niega a iniciar con ella: no se enviará nada hasta que se resuelva.',
  'The customer list came back capped, so some customers are missing from it. A run refuses to start in this state rather than quietly leaving the same customers out every week - nothing will be sent until it is resolved.':
    'La lista de clientes llegó truncada, así que faltan algunos clientes. Una ejecución se niega a iniciar en este estado en lugar de omitir en silencio a los mismos clientes cada semana: no se enviará nada hasta que se resuelva.',
  'Would be emailed': 'Se enviarían por correo',
  'on the next run': 'en la próxima ejecución',
  'blocked - see below': 'bloqueado; vea abajo',
  'Eligible customers': 'Clientes elegibles',
  'of {count} with a statement': 'de {count} con estado de cuenta',
  'Cannot be sent': 'No se pueden enviar',
  'reasons listed below': 'motivos indicados abajo',
  'Billing week': 'Semana de facturación',
  'as of {date}': 'al {date}',
  'Who will receive a statement': 'Quién recibirá un estado de cuenta',
  'Who would receive a statement': 'Quién recibiría un estado de cuenta',
  'Each statement goes to the listed address and any CC recipients shown here.':
    'Cada estado de cuenta se envía a la dirección indicada y a los destinatarios en copia que se muestran aquí.',
  CC: 'Con copia',
  'Nothing is being emailed. This is who would be contacted, at these addresses, if every condition below were met.':
    'No se está enviando nada por correo. Estos son los clientes que se contactarían, en estas direcciones, si se cumplieran todas las condiciones de abajo.',
  'Counted for the run in the week of {weekOf}.':
    'Contados para la ejecución de la semana del {weekOf}.',
  'No customer is eligible to receive a statement.':
    'Ningún cliente es elegible para recibir un estado de cuenta.',
  'Customers who would receive a statement': 'Clientes que recibirían un estado de cuenta',
  'Statement goes to': 'El estado de cuenta se envía a',
  'Amount due': 'Importe adeudado',
  'Showing the first {count}. More customers are eligible than are listed here.':
    'Se muestran los primeros {count}. Hay más clientes elegibles de los que se listan aquí.',
  'What has to be true before anything is emailed':
    'Qué debe cumplirse antes de que se envíe algo por correo',
  'Every one of these must be ready. Any single one being off means no customer is contacted.':
    'Todas estas condiciones deben estar listas. Si falla una sola, no se contacta a ningún cliente.',
  'Sending is switched on for this deployment': 'El envío está activado en esta implementación',
  'The weekly schedule is armed': 'La programación semanal está activada',
  'A mailbox is connected': 'Hay un buzón conectado',
  'No mailbox is connected.': 'No hay ningún buzón conectado.',
  'Connected.': 'Conectado.',
  'Connected as {mailbox}.': 'Conectado como {mailbox}.',
  'Reading the live QuickBooks company file':
    'Leyendo el archivo de empresa de QuickBooks en producción',
  'Statements are built from the production ledger.':
    'Los estados de cuenta se generan desde el libro mayor de producción.',
  'Reading the {environment} company file. A live run refuses this.':
    'Leyendo el archivo de empresa {environment}. Una ejecución real lo rechaza.',
  // The server's own gate sentences (statement-sender.service.ts)
  'STATEMENTS_SENDING_ENABLED is "true"': 'STATEMENTS_SENDING_ENABLED es "true"',
  'STATEMENTS_SENDING_ENABLED is not "true" - nothing can leave this deployment':
    'STATEMENTS_SENDING_ENABLED no es "true"; nada puede salir de esta implementación',
  'STATEMENTS_SCHEDULE_ARMED is "true" - the weekly run is unattended':
    'STATEMENTS_SCHEDULE_ARMED es "true"; la ejecución semanal es desatendida',
  'STATEMENTS_SCHEDULE_ARMED is not "true" - the weekly run will not fire on its own':
    'STATEMENTS_SCHEDULE_ARMED no es "true"; la ejecución semanal no se disparará por sí sola',
  'No sending mailbox is connected.': 'No hay ningún buzón de envío conectado.',
  'Who cannot be sent a statement': 'A quién no se le puede enviar un estado de cuenta',
  'These customers have an open balance and are being held back. Nothing goes to them.':
    'Estos clientes tienen saldo abierto y están retenidos. No se les envía nada.',
  'Nobody is being held back - every customer with a balance can be sent a statement.':
    'Nadie está retenido: a todos los clientes con saldo se les puede enviar un estado de cuenta.',
  'Customers who cannot be sent a statement':
    'Clientes a los que no se les puede enviar un estado de cuenta',
  'Showing the first {count}. More customers are being held back than are listed here.':
    'Se muestran los primeros {count}. Hay más clientes retenidos de los que se listan aquí.',
  // Refusal codes (refusalLabel)
  'Statements are paused for this customer':
    'Los estados de cuenta están en pausa para este cliente',
  'No billing email on file': 'No hay correo electrónico de facturación registrado',
  'The billing email is not a usable address':
    'El correo electrónico de facturación no es una dirección utilizable',
  'Total disagrees with QuickBooks': 'El total no coincide con QuickBooks',
  'Nothing owed': 'No debe nada',
  'Already sent this week': 'Ya se envió esta semana',
  'Their statement could not be produced': 'No se pudo generar su estado de cuenta',
  'No statement was built for them': 'No se generó ningún estado de cuenta para este cliente',
  'The mailbox refused the address': 'El buzón rechazó la dirección',
  'Released by an admin so the week could be re-run':
    'Liberado por un administrador para poder repetir la semana',
  // Held-back codes (heldBackLabel)
  'Not yet confirmed as a practice': 'Aún no confirmado como consultorio',
  'Marked as not a practice': 'Marcado como «no es un consultorio»',
  'No clinic record in this company file': 'No hay registro de clínica en este archivo de empresa',
  'Archived in QuickBooks': 'Archivado en QuickBooks',
  'A sub-customer, billed through its parent':
    'Un subcliente, facturado a través de su cliente principal',
  'Not billed in dollars': 'No se factura en dólares',
  // Run history
  'Run history': 'Historial de ejecuciones',
  'Every run, including rehearsals. A rehearsal leaves the same record a real send does.':
    'Todas las ejecuciones, incluidos los ensayos. Un ensayo deja el mismo registro que un envío real.',
  'Refresh the run history': 'Actualizar el historial de ejecuciones',
  'The run history could not be read. The status above is still current.':
    'No se pudo leer el historial de ejecuciones. El estado de arriba sigue vigente.',
  'No run has ever happened on this deployment.':
    'Nunca ha habido una ejecución en esta implementación.',
  Started: 'Inicio',
  Week: 'Semana',
  'Held back': 'Retenidos',
  Stopped: 'Detenida',
  Emailed: 'Envío real',
  Rehearsal: 'Ensayo',
  // Run detail
  'Could not load that run.': 'No se pudo cargar esa ejecución.',
  'Run detail': 'Detalle de la ejecución',
  '{stamp} - week of {weekOf}': '{stamp} - semana del {weekOf}',
  'This run stopped:': 'Esta ejecución se detuvo:',
  'This run never finished. Some customers may have been claimed without being emailed.':
    'Esta ejecución nunca terminó. Es posible que algunos clientes hayan quedado reclamados sin recibir el correo.',
  'This was a rehearsal. No customer was emailed, whatever the outcomes below say.':
    'Esto fue un ensayo. No se envió correo a ningún cliente, digan lo que digan los resultados de abajo.',
  Outcome: 'Resultado',
  'This run reached no customers.': 'Esta ejecución no alcanzó a ningún cliente.',
  'Showing the first 1,000 customers of this run.':
    'Se muestran los primeros 1,000 clientes de esta ejecución.',

  // Recipients tab
  'Could not load statements.': 'No se pudieron cargar los estados de cuenta.',
  'Generating statements...': 'Generando estados de cuenta...',
  'This can take 5-10 seconds.': 'Esto puede tardar de 5 a 10 segundos.',
  'Generating PDF': 'Generando PDF',
  'This can take 10-15 seconds.': 'Esto puede tardar de 10 a 15 segundos.',
  '{name}: these figures are from {asOf}. Refresh before pausing or resuming - someone may have changed this record since.':
    '{name}: estas cifras son del {asOf}. Actualice antes de pausar o reanudar; alguien puede haber cambiado este registro desde entonces.',
  '{name} paused. They stay on this list and will not be sent a statement.':
    '{name} en pausa. Permanece en esta lista y no se le enviará un estado de cuenta.',
  '{name} resumed. They will be sent a statement again.':
    '{name} reanudado. Se le volverá a enviar un estado de cuenta.',
  '{name} could not be paused: {reason}': 'No se pudo pausar a {name}: {reason}',
  '{name} could not be resumed: {reason}': 'No se pudo reanudar a {name}: {reason}',
  'the change was not saved': 'el cambio no se guardó',
  '{name}: these figures are from {asOf}. Refresh before ruling on a customer - someone may have changed this record since.':
    '{name}: estas cifras son del {asOf}. Actualice antes de decidir sobre un cliente; alguien puede haber cambiado este registro desde entonces.',
  '{name} confirmed as a practice.': '{name} confirmado como consultorio.',
  '{name} could not be confirmed: {reason}': 'No se pudo confirmar a {name}: {reason}',
  'The file could not be created: {reason}': 'No se pudo crear el archivo: {reason}',
  'matching "{search}"': 'que coinciden con "{search}"',
  'Exported {count} customer to {file}': 'Se exportó {count} cliente a {file}',
  'Exported {count} customers to {file}': 'Se exportaron {count} clientes a {file}',
  '- the rows currently shown ({scope}), not the whole list.':
    '- las filas que se muestran actualmente ({scope}), no la lista completa.',
  'The list itself was capped, so some customers are missing from it.':
    'La lista en sí estaba truncada, así que faltan algunos clientes.',
  '{count} name starting with = + - or @ gained a leading apostrophe, so a spreadsheet cannot execute them as formulas - they will not match QuickBooks exactly.':
    '{count} nombre que empieza con = + - o @ recibió un apóstrofo inicial para que una hoja de cálculo no lo ejecute como fórmula; no coincidirá exactamente con QuickBooks.',
  '{count} names starting with = + - or @ gained a leading apostrophe, so a spreadsheet cannot execute them as formulas - they will not match QuickBooks exactly.':
    '{count} nombres que empiezan con = + - o @ recibieron un apóstrofo inicial para que una hoja de cálculo no los ejecute como fórmulas; no coincidirán exactamente con QuickBooks.',
  'Refresh before opening a statement - these figures are from {asOf}, so the document would not match this page.':
    'Actualice antes de abrir un estado de cuenta: estas cifras son del {asOf}, así que el documento no coincidiría con esta página.',
  "{count} character(s) could not be printed on {name}'s statement and were left out of the document.":
    '{count} carácter(es) no se pudieron imprimir en el estado de cuenta de {name} y se omitieron del documento.',
  'Could not render that statement.': 'No se pudo generar ese estado de cuenta.',
  'Total of {count} customer': 'Total de {count} cliente',
  'Total of {count} customers': 'Total de {count} clientes',
  'Total of {count} shown': 'Total de {count} mostrados',
  '{label}, {amount} due.': '{label}, {amount} adeudado.',
  // Advisory strip
  '{count} not on this list': '{count} fuera de esta lista',
  'Held back when the ledger was read:': 'Retenidos al leer el libro mayor:',
  'A customer nobody has ruled on can be confirmed here, on its own row. Reversing an explicit':
    'Un cliente sobre el que nadie ha decidido puede confirmarse aquí, en su propia fila. Revertir una marca explícita de',
  'not a practice': 'no es un consultorio',
  'is done on the': 'se hace desde la página',
  "page, which is where the rest of that decision's consequences are visible. Until one or the other happens they receive nothing, which is the intended behaviour - a statement asks someone for money, so the account has to have been looked at by a person first.":
    'que es donde se ven las demás consecuencias de esa decisión. Hasta que ocurra una de las dos cosas no reciben nada, y ese es el comportamiento previsto: un estado de cuenta pide dinero a alguien, así que una persona debe haber revisado la cuenta primero.',
  '{count} never confirmed as a practice': '{count} nunca confirmados como consultorio',
  'Nobody has ruled on them either way. They are included here and would be sent a statement. Anything that is not a practice - a bank row, a transfer, a supplier - should be marked':
    'Nadie ha decidido sobre ellos en ningún sentido. Se incluyen aquí y se les enviaría un estado de cuenta. Todo lo que no sea un consultorio (una fila bancaria, una transferencia, un proveedor) debe marcarse como',
  'on the': 'en la página',
  'page before sending is ever switched on. The ones that ARE practices can be confirmed on their own row here - filter to':
    'antes de activar el envío. Los que SÍ son consultorios pueden confirmarse aquí en su propia fila; filtre por',
  'to work down them.': 'para recorrerlos.',
  '{count} address the mailbox will reject': '{count} dirección que el buzón rechazará',
  '{count} addresses the mailbox will reject': '{count} direcciones que el buzón rechazará',
  'They would receive nothing. Usually it is two addresses in one QuickBooks field; the fix is in QuickBooks.':
    'No recibirían nada. Normalmente son dos direcciones en un mismo campo de QuickBooks; la corrección se hace en QuickBooks.',
  'no address': 'sin dirección',
  '{count} disagrees with QuickBooks': '{count} no coincide con QuickBooks',
  '{count} disagree with QuickBooks': '{count} no coinciden con QuickBooks',
  'Those totals should not be sent to a customer until the difference is explained.':
    'Esos totales no deberían enviarse a un cliente hasta que se explique la diferencia.',
  'we show {ours}, QuickBooks says {theirs}': 'nosotros mostramos {ours}, QuickBooks dice {theirs}',
  'Ageing may be wrong': 'La antigüedad puede ser incorrecta',
  'Every invoice was aged from its transaction date because none carried a due date. That is usually a broken read, not real data - the whole ledger will look one bucket more overdue than it is.':
    'La antigüedad de todas las facturas se calculó desde su fecha de transacción porque ninguna tenía fecha de vencimiento. Eso suele ser una lectura defectuosa, no datos reales: todo el libro mayor parecerá un tramo más vencido de lo que está.',
  // Banners and tiles
  'These figures were read on': 'Estas cifras se leyeron el',
  'and it is now': 'y ahora es',
  'in Eastern. Balances and ageing have moved on since, and a statement cannot be opened until the page catches up.':
    'en hora del Este. Los saldos y la antigüedad han cambiado desde entonces, y no se puede abrir un estado de cuenta hasta que la página se actualice.',
  'Refresh now': 'Actualizar ahora',
  'Customers with a balance': 'Clientes con saldo',
  'Total owed': 'Total adeudado',
  'Disagree with QuickBooks': 'No coinciden con QuickBooks',
  'Aged as of': 'Antigüedad al',
  // Toolbar and table
  'Search by customer or email address...': 'Buscar por cliente o correo electrónico...',
  'Filter customers': 'Filtrar clientes',
  'All customers': 'Todos los clientes',
  'Past due (any bucket)': 'Vencidos (cualquier tramo)',
  '90+ days overdue': 'Más de 90 días de vencimiento',
  '61-90 days overdue': '61-90 días de vencimiento',
  '31-60 days overdue': '31-60 días de vencimiento',
  '1-30 days overdue': '1-30 días de vencimiento',
  'Has an unapplied credit': 'Tiene un crédito sin aplicar',
  'Disagrees with QuickBooks': 'No coincide con QuickBooks',
  'Statements paused': 'Estados de cuenta en pausa',
  'Email will be rejected': 'El correo electrónico será rechazado',
  'Export CSV': 'Exportar CSV',
  'Customers with an open balance, aged into buckets, with how overdue the oldest document on each account is and the amount each owes.':
    'Clientes con saldo abierto, clasificados por antigüedad en tramos, con el vencimiento del documento más antiguo de cada cuenta y el importe que debe cada uno.',
  'Not overdue': 'No vencido',
  '1-30 days': '1-30 días',
  '31-60 days': '31-60 días',
  '61-90 days': '61-90 días',
  '90+ days': 'Más de 90 días',
  Oldest: 'Más antiguo',
  'Total due': 'Total adeudado',
  'No customers match that search or filter.': 'Ningún cliente coincide con esa búsqueda o filtro.',
  'No customers would receive a statement - every one with a balance is held back, for the reasons above.':
    'Ningún cliente recibiría un estado de cuenta: todos los que tienen saldo están retenidos, por los motivos de arriba.',
  'No customers would receive a statement.': 'Ningún cliente recibiría un estado de cuenta.',
  'An admin paused weekly statements for this customer. They stay on this list and are never sent one.':
    'Un administrador pausó los estados de cuenta semanales de este cliente. Permanece en esta lista y nunca se le envía uno.',
  Paused: 'En pausa',
  'No billing email - cannot be sent': 'Sin correo electrónico de facturación; no se puede enviar',
  'The mailbox will not accept this address - usually two addresses in one QuickBooks field. Fix it in QuickBooks.':
    'El buzón no aceptará esta dirección; normalmente son dos direcciones en un mismo campo de QuickBooks. Corríjalo en QuickBooks.',
  'will be rejected': 'será rechazado',
  'Nobody has recorded whether this is a real practice. It would still be sent a statement.':
    'Nadie ha registrado si este es un consultorio real. Aun así se le enviaría un estado de cuenta.',
  'Confirm {name} as a practice': 'Confirmar {name} como consultorio',
  'Confirm as a practice': 'Confirmar como consultorio',
  'The oldest overdue document on this account is {days} days past due.':
    'El documento vencido más antiguo de esta cuenta lleva {days} días de vencimiento.',
  'Nothing on this account is overdue.': 'Nada en esta cuenta está vencido.',
  'This deployment did not report how overdue this account is.':
    'Esta implementación no informó el vencimiento de esta cuenta.',
  '{days}d': '{days} d',
  'Nothing overdue': 'Nada vencido',
  'Not reported': 'No informado',
  'QuickBooks says {balance}. Difference {delta}.':
    'QuickBooks dice {balance}. Diferencia: {delta}.',
  disagrees: 'no coincide',
  'Resume weekly statements': 'Reanudar los estados de cuenta semanales',
  'Pause weekly statements': 'Pausar los estados de cuenta semanales',
  'Resume statements for {name}': 'Reanudar los estados de cuenta de {name}',
  'Pause statements for {name}': 'Pausar los estados de cuenta de {name}',
  'Opening...': 'Abriendo...',
  'View PDF': 'Ver PDF',
  'Showing {shown} of {count} customers - the list was capped, and the search box and filter only narrow what was fetched. A customer missing from this page may still have a balance, and the totals row states which of the two populations it is adding up.':
    'Se muestran {shown} de {count} clientes: la lista estaba truncada, y la búsqueda y el filtro solo acotan lo que se obtuvo. Un cliente que falte en esta página puede tener saldo igualmente, y la fila de totales indica cuál de las dos poblaciones está sumando.',
  // Line items
  'No open documents on this account.': 'No hay documentos abiertos en esta cuenta.',
  Document: 'Documento',
  Due: 'Vence',
  'Days past due': 'Días de vencimiento',
  'This account has {total} open documents; only the first {shown} are shown and printed.':
    'Esta cuenta tiene {total} documentos abiertos; solo se muestran e imprimen los primeros {shown}.',

  // Credit limit messages tab
  'Could not load customers.': 'No se pudieron cargar los clientes.',
  "This text prints on the customer's statement under":
    'Este texto se imprime en el estado de cuenta del cliente bajo',
  'Credit limit and account terms': 'Límite de crédito y condiciones de la cuenta',
  '. It is saved exactly as it will appear, and only this customer ever sees it.':
    '. Se guarda exactamente como aparecerá, y solo este cliente lo ve.',
  'the list was capped - more exist': 'la lista estaba truncada; existen más',
  'With terms set': 'Con condiciones definidas',
  '{count} have none': '{count} no tienen',
  'Character limit': 'Límite de caracteres',
  'per customer': 'por cliente',
  'Search customers...': 'Buscar clientes...',
  'Practices only': 'Solo consultorios',
  'What prints on their statement': 'Qué se imprime en su estado de cuenta',
  'No customers match that search.': 'Ningún cliente coincide con esa búsqueda.',
  'No customers found.': 'No se encontraron clientes.',
  'Not a practice': 'No es un consultorio',
  'Nothing - their statement shows no credit terms':
    'Nada; su estado de cuenta no muestra condiciones de crédito',
  '{count} record hidden - suppliers, bank-feed entries and other non-practice customers. Untick “Practices only” to see them.':
    '{count} registro oculto: proveedores, entradas bancarias y otros clientes que no son consultorios. Desmarque “Solo consultorios” para verlos.',
  '{count} records hidden - suppliers, bank-feed entries and other non-practice customers. Untick “Practices only” to see them.':
    '{count} registros ocultos: proveedores, entradas bancarias y otros clientes que no son consultorios. Desmarque “Solo consultorios” para verlos.',
  'Showing the first {count} customers; the list was capped. Search filters only what was fetched.':
    'Se muestran los primeros {count} clientes; la lista estaba truncada. La búsqueda solo filtra lo que se obtuvo.',

  // Credit limit message editor
  'Could not load this message.': 'No se pudo cargar este mensaje.',
  'Could not load the template.': 'No se pudo cargar la plantilla.',
  'Could not save this message.': 'No se pudo guardar este mensaje.',
  'Could not clear this message.': 'No se pudo borrar este mensaje.',
  'Replace what you have typed with the standard wording?':
    '¿Reemplazar lo que ha escrito con el texto estándar?',
  'Saved. {count} character(s) could not be printed on a statement and were removed.':
    'Guardado. {count} carácter(es) no se pudieron imprimir en un estado de cuenta y se eliminaron.',
  'Saved. The text was reformatted so that what is stored is exactly what will print.':
    'Guardado. El texto se reformateó para que lo guardado sea exactamente lo que se imprimirá.',
  'Remove the credit terms for {name}? Their statements will print no credit terms, and there is no way to recover the text.':
    '¿Quitar las condiciones de crédito de {name}? Sus estados de cuenta no imprimirán condiciones de crédito, y no hay forma de recuperar el texto.',
  'The previous wording is back in the box, but it has not been saved yet - press Save to keep it.':
    'El texto anterior está de nuevo en el cuadro, pero aún no se ha guardado; haga clic en Guardar para conservarlo.',
  'Put the previous wording back': 'Restaurar el texto anterior',
  'Credit limit message': 'Mensaje de límite de crédito',
  'Your current credit limit is: $...': 'Su límite de crédito actual es: $...',
  'Use the standard wording': 'Usar el texto estándar',
  'Remove message': 'Quitar mensaje',

  // PDF placeholder tab title.
  'Generating statement...': 'Generando estado de cuenta...',

  // unwrap() failures - one sentence per thing the page asks the API for.
  'The API did not return a run history. This usually means the app is pointed at the wrong address.':
    'La API no devolvió un historial de ejecuciones. Esto suele significar que la aplicación apunta a la dirección equivocada.',
};

export default statements;
